import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { purchaseDrService } from "./purchaseDrService";
import useGlobalModel from "@/model/globalModel";
import { ISCMPurchaseDrSearchFields, ISCMPurchaseDrDetail, ISCMPurchaseDrStatistics } from "./purchaseDrTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";
import { isArray } from "util";
import { roleColumnModel } from "@/utils/roleColumn";

export const usePurchaseDrModel = createModel(function () {
    const { user: { shopId, shopCode }, shopAndOrg, setLoadingInfo } = useGlobalModel();
    const { getHideRoleColumns } = roleColumnModel();
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMPurchaseDrSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMPurchaseDrDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //列表统计展示数据
    const initStatistics = {
        // aggregateAmount: "0.00",
        // paidAmount: "0.00",
        totalAmount: "0.00",
        totalNum: 0
    };
    const [statistics, setStatistics] = useState<ISCMPurchaseDrStatistics>(initStatistics);
    const [loading, setLoading] = useState<boolean>(false);

    const updateSearchParam = (updateParam: ISCMPurchaseDrSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //切换站点重置缓存
    useEffect(() => {
        setSearchParam({});
        setSelectedRowKeys([]);
    }, [shopId]);

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: ISCMPurchaseDrSearchFields = searchParam) => {
        setLoading(true);
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId,
            // outShopType: searchValue.outShopId !== undefined ? 1 : null,
            // outShopId: searchValue.outShopId,
        };
        const { shopId, outShopId, ...newSearchValue } = searchValue;
        const searchParams = {
            branchIn: "vrm",
            ...newSearchValue,
            ...shopParam,
            status: isArray(searchValue?.status) ? searchValue?.status.join() : searchValue?.status,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await purchaseDrService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
        loadTotal(searchParams);
    }

    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await purchaseDrService.pageStatistics(searchParams);
        setStatistics(statistics ?? initStatistics);
    }

    //导出
    const exportPurchaseDr = async (searchValue: ISCMPurchaseDrSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
                shopId: searchValue.shopId ?? shopAndOrg.shopId,
                // outShopType: searchValue.outShopId !== undefined ? 1 : null,
                // outShopId: searchValue.outShopId,
            };
            const searchParams = {
                inAndOut: "0",
                ...searchValue,
                ...shopParam,
                status: isArray(searchValue?.status) ? searchValue?.status.join() : searchValue?.status,
                pageSize: -1,
                pageNum: 1,
                hidden: getHideRoleColumns("purchaseIn", "主单"),
                hiddenDetail: getHideRoleColumns("purchaseIn", "明细"),
            }
            let result = await purchaseDrService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    const exportStatisticsExport = async (searchValue: ISCMPurchaseDrSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const shopParam = {
                shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
                shopId: searchValue.shopId ?? shopAndOrg.shopId,
                // outShopType: searchValue.outShopId !== undefined ? 1 : null,
                // outShopId: searchValue.outShopId,
            };
            const searchParams = {
                inAndOut: "0",
                ...searchValue,
                ...shopParam,
                status: isArray(searchValue?.status) ? searchValue?.status.join() : searchValue?.status,
                pageSize: -1,
                pageNum: 1,
            }
            let result = await purchaseDrService.statisticsExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        statistics,
        loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportPurchaseDr,
        exportStatisticsExport
    }
});